
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/project/[projectId]/test/[testId]",
      function () {
        return require("private-next-pages/project/[projectId]/test/[testId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/project/[projectId]/test/[testId]"])
      });
    }
  